import PropTypes from 'prop-types';
import React from 'react';

const ProviderClaimSecure = ({ height }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="135"
    height={height || '52'}
    viewBox="0 0 241 52"
    style={{ enableBackground: 'new 0 0 241 52' }}
    xmlSpace="preserve"
  >
    <g>
      <path
        fill="#1E428A"
        d="M236.3,21.8c0.5,0.7,0.7,1.6,0.7,2.5h-8.2c0-0.7,0.2-1.5,0.9-2.2c0.9-1.1,2-1.6,3.4-1.6
    C234.4,20.5,235.5,21,236.3,21.8L236.3,21.8z M241,27v-1c0-2.7-0.6-4.7-1.8-6.3c-1.4-1.6-3.4-2.5-5.9-2.5c-2.2,0-3.9,0.6-5.4,1.7
    c-2.3,1.6-3.4,4.5-3.4,8.6s1,7.1,2.9,9.3c1.8,2,4.4,2.9,7.7,2.9c1.6,0,3.4-0.2,5.4-0.7v-3.2c-1.5,0.5-2.8,0.7-4.1,0.7
    c-2.7,0-4.7-1.1-6.1-3.3c-1.2-1.8-1.7-3.9-1.7-6.4H241V27z"
      />
      <path
        fill="#1E428A"
        d="M224.4,21.8v-4.5c-1.8,0-3.4,0.6-4.7,1.8c-0.9,0.9-1.6,1.8-2,3.1h-0.1v-4.4h-4.1v21.6h4.1v-9.2
    C217.7,24.7,220,21.8,224.4,21.8L224.4,21.8z"
      />
      <path
        fill="#1E428A"
        d="M211.6,39.4V17.8h-4.1V27c0,2.2-0.5,4.3-1.6,6c-1.1,1.8-2.5,2.8-4.1,2.8c-1.4,0-2.2-0.6-2.6-1.6
    c-0.2-0.7-0.4-2.2-0.4-4.7V17.7h-4.1v15c0,1.8,0.4,3.3,1,4.5c1,1.7,2.6,2.6,4.8,2.6c3.3,0,5.5-1.7,6.8-5.2h0.1v4.7L211.6,39.4
    L211.6,39.4z"
      />
      <path
        fill="#1E428A"
        d="M170.9,21.8c0.6,0.7,0.9,1.6,0.9,2.5h-8.2c0-0.7,0.2-1.5,0.9-2.2c0.9-1.1,2-1.6,3.4-1.6
    C169.2,20.5,170.3,21,170.9,21.8L170.9,21.8z M162.5,19c-2.2,1.6-3.3,4.5-3.3,8.6s1,7.1,2.9,9.3c1.8,2,4.4,2.9,7.7,2.9
    c1.6,0,3.3-0.2,5.4-0.7v-3.2c-1.6,0.5-2.9,0.7-4.1,0.7c-2.7,0-4.8-1.1-6.1-3.3c-1.2-1.8-1.8-3.9-1.8-6.4h12.5v-1
    c0-2.7-0.6-4.7-2-6.3c-1.4-1.6-3.3-2.5-5.8-2.5C165.9,17.3,164,17.9,162.5,19L162.5,19z"
      />
      <path
        fill="#1E428A"
        d="M152.3,20.5c1.6,0,3.2,0.5,5,1.4v-3.7l-2.1-0.5c-1-0.2-2-0.4-2.8-0.4c-2.3,0-4.2,0.6-5.5,1.6
    c-1.5,1.1-2.2,2.6-2.2,4.4c0,1.5,0.6,2.7,1.5,3.7c0.6,0.6,1.6,1.4,2.8,2.2l4.3,2.7c0.9,0.7,1.2,1.4,1.2,2c0,2-1.4,2.8-4.3,2.8
    c-1.7,0-3.4-0.4-5.5-1.2v3.6c2.2,0.6,4.1,0.9,5.9,0.9c2.5,0,4.4-0.5,5.8-1.6c1.5-1.1,2.2-2.7,2.2-4.9c0-1.6-0.5-2.9-1.6-4.1
    c-0.6-0.5-1.6-1.4-3.3-2.3l-1.7-1c-1.2-0.7-1.8-1.2-2.1-1.4c-0.7-0.6-1-1.2-1-1.8c0-0.6,0.4-1.2,1.1-1.7
    C150.6,20.7,151.5,20.5,152.3,20.5L152.3,20.5z"
      />
      <path
        fill="#1E428A"
        d="M188.8,24.8h4.7c0-2.1-0.5-3.7-1.6-5c-1.2-1.6-3.3-2.5-6.1-2.5c-3.1,0-5.4,1.1-7,3.1c-1.5,1.8-2.2,4.3-2.2,7.5
    s0.7,5.9,2.2,8c1.8,2.7,4.7,4.1,8.3,4.1c2.3,0,4.3-0.2,6-0.9v-2.8c-1,0.4-2.1,0.5-3.4,0.5c-3.1,0-5.4-1.1-6.9-3.2
    c-1.1-1.7-1.7-3.8-1.7-6.4c0-2,0.5-3.7,1.2-4.8c0.7-1.2,1.8-1.8,3.2-1.8C187.7,20.5,188.8,22,188.8,24.8L188.8,24.8z"
      />
      <path
        fill="#C9CBCC"
        d="M143.2,22c0-1.2-0.5-2.2-1.4-3.1c-0.7-0.7-1.7-1.1-2.8-1.1c-1.7,0-3.4,0.7-4.9,2c-1,0.9-1.8,2-2.3,3.1h-0.1V22
    c0-0.9-0.4-1.7-1-2.6c-0.7-1.1-1.8-1.6-3.2-1.6c-1.8,0-3.4,0.7-4.9,2.1c-1,0.9-1.7,1.8-2.3,3.1l-0.1-0.1l0.9-4.5h-3.2l-4.2,21.1
    h3.3l1.8-9.3c0.4-2.2,1.1-4.2,2.1-5.9c1.5-2.5,3.1-3.7,5-3.7c0.7,0,1.2,0.2,1.7,0.9c0.4,0.5,0.6,1.1,0.6,1.8c0,0.2-0.1,1.2-0.4,3.1
    l-2.6,13.1h3.2l1.8-9.3c0.4-2.1,1.1-3.9,2-5.5c1.4-2.7,3.1-4.1,5-4.1c0.7,0,1.4,0.2,1.8,0.7c0.4,0.5,0.6,1,0.6,1.7
    c0,1-0.1,2.1-0.4,3.1l-2.6,13.4h3.3l2.8-14.6C143.1,23.8,143.2,22.9,143.2,22L143.2,22z"
      />
      <polygon fill="#C9CBCC" points="90.5,8.8 87.2,8.8 81.3,39.4 84.5,39.4   " />
      <polygon
        fill="#C9CBCC"
        points="116.6,8.8 112.5,8.8 111.8,12.8 115.7,12.8   "
      />
      <path
        fill="#C9CBCC"
        d="M68,21.8c-1.8,2.5-2.7,5.5-2.7,9.2c0,5.9,3.1,8.8,9,8.8c1.2,0,2.8-0.2,4.5-0.7l0.5-2.1
    c-1.6,0.5-2.8,0.7-3.8,0.7c-2.3,0-4.1-0.9-5.2-2.5c-0.9-1.4-1.4-3.2-1.4-5.4c0-2.8,0.6-5.2,1.7-7.1c1.2-2,2.7-2.9,4.5-2.9
    c2.1,0,3.1,1.1,3.1,3.2c0,0.2,0,0.7-0.1,1.7h3.8C82,24,82,23.3,82,22.9c0-1.5-0.5-2.7-1.7-3.7c-1.1-1-2.7-1.5-4.7-1.5
    C72.4,17.8,69.8,19.1,68,21.8L68,21.8z"
      />
      <polygon
        fill="#C9CBCC"
        points="114.4,18.3 111.1,18.3 107,39.4 110.2,39.4   "
      />
      <path
        fill="#C9CBCC"
        d="M98.4,19.9c1.4,0,2.5,0.7,3.2,2.2c0.5,1.1,0.7,2.2,0.7,3.7c0,2.5-0.5,4.9-1.4,7.2c-1.2,3.2-3.1,4.8-5.4,4.8
    c-2.2,0-3.3-1.8-3.3-5.6c0-2.8,0.5-5.4,1.4-7.9C94.9,21.3,96.5,19.9,98.4,19.9L98.4,19.9z M103.6,21.7c-1.1-2.6-2.9-3.9-5.5-3.9
    c-3.1,0-5.5,1.6-7.2,4.9c-1.5,2.7-2.2,5.9-2.2,9.6c0,2.3,0.5,4.1,1.4,5.4c1,1.5,2.5,2.2,4.5,2.2c2.8,0,5-1.5,6.3-4.2l0.1,0.1
    l-0.6,3.6h3.2l4.1-21.1h-3.3L103.6,21.7L103.6,21.7L103.6,21.7z"
      />
      <path
        fill="#646569"
        d="M143.2,22c0-1.2-0.5-2.2-1.4-3.1c-0.7-0.7-1.7-1.1-2.8-1.1c-1.7,0-3.4,0.7-4.9,2c-1,0.9-1.8,2-2.3,3.1h-0.1V22
    c0-0.9-0.4-1.7-1-2.6c-0.7-1.1-1.8-1.6-3.2-1.6c-1.8,0-3.4,0.7-4.9,2.1c-1,0.9-1.7,1.8-2.3,3.1l-0.1-0.1l0.9-4.5h-3.2l-4.2,21.1
    h3.3l1.8-9.3c0.4-2.2,1.1-4.2,2.1-5.9c1.5-2.5,3.1-3.7,5-3.7c0.7,0,1.2,0.2,1.7,0.9c0.4,0.5,0.6,1.1,0.6,1.8c0,0.2-0.1,1.2-0.4,3.1
    l-2.6,13.1h3.2l1.8-9.3c0.4-2.1,1.1-3.9,2-5.5c1.4-2.7,3.1-4.1,5-4.1c0.7,0,1.4,0.2,1.8,0.7c0.4,0.5,0.6,1,0.6,1.7
    c0,1-0.1,2.1-0.4,3.1l-2.6,13.4h3.3l2.8-14.6C143.1,23.8,143.2,22.9,143.2,22L143.2,22z"
      />
      <polygon fill="#646569" points="90.6,9 87.3,9 81.4,39.6 84.6,39.6   " />
      <polygon
        fill="#646569"
        points="116.6,8.8 112.5,8.8 111.8,12.8 115.7,12.8   "
      />
      <path
        fill="#646569"
        d="M68,21.8c-1.8,2.5-2.7,5.5-2.7,9.2c0,5.9,3.1,8.8,9,8.8c1.2,0,2.8-0.2,4.5-0.7l0.5-2.1
    c-1.6,0.5-2.8,0.7-3.8,0.7c-2.3,0-4.1-0.9-5.2-2.5c-0.9-1.4-1.4-3.2-1.4-5.4c0-2.8,0.6-5.2,1.7-7.1c1.2-2,2.7-2.9,4.5-2.9
    c2.1,0,3.1,1.1,3.1,3.2c0,0.2,0,0.7-0.1,1.7h3.8C82,24,82,23.3,82,22.9c0-1.5-0.5-2.7-1.7-3.7c-1.1-1-2.7-1.5-4.7-1.5
    C72.4,17.8,69.8,19.1,68,21.8L68,21.8z"
      />
      <polygon
        fill="#646569"
        points="114.4,18.3 111.1,18.3 107,39.4 110.2,39.4"
      />
      <path
        fill="#646569"
        d="M98.4,19.9c1.4,0,2.5,0.7,3.2,2.2c0.5,1.1,0.7,2.2,0.7,3.7c0,2.5-0.5,4.9-1.4,7.2c-1.2,3.2-3.1,4.8-5.4,4.8
    c-2.2,0-3.3-1.8-3.3-5.6c0-2.8,0.5-5.4,1.4-7.9C94.9,21.3,96.5,19.9,98.4,19.9L98.4,19.9z M103.6,21.7c-1.1-2.6-2.9-3.9-5.5-3.9
    c-3.1,0-5.5,1.6-7.2,4.9c-1.5,2.7-2.2,5.9-2.2,9.6c0,2.3,0.5,4.1,1.4,5.4c1,1.5,2.5,2.2,4.5,2.2c2.8,0,5-1.5,6.3-4.2l0.1,0.1
    l-0.6,3.6h3.2l4.1-21.1h-3.3L103.6,21.7L103.6,21.7L103.6,21.7z"
      />
      <path
        fill="#1E428A"
        d="M55.5,11.9C43.6-2.4,9.7,2.3,9.7,17.4c0,5.8,6.7,10.9,16,12.6c12.6,2.3,9.8,11.9,1.9,11.6
    C12.2,41,0,31.9,0,20.7C0-2.2,42.9-7.4,55.5,11.9L55.5,11.9z"
      />
      <path
        fill="#646569"
        d="M4.6,40.3c11.9,14.3,45.8,9.6,45.8-5.5c0-5.8-6.7-10.9-16-12.6c-12.6-2.3-9.8-11.9-1.9-11.6
    c15.4,0.6,27.6,9.7,27.6,20.9C60,54.4,17.2,59.6,4.6,40.3L4.6,40.3z"
      />
    </g>
  </svg>
);
ProviderClaimSecure.propTypes = {
  height: PropTypes.string,
};

export default ProviderClaimSecure;
